import React from 'react';
import moment from 'moment';
import { Select } from 'antd';
import { createReducer } from '../../../../utils/reducerUtil';
import { ACTION_STATUS } from '../../../../utils/ActionStatus';

import {
    RULE_MASTER_QUERY_INPUT_CHANGE,
    START_LOAD_RULE_MASTER,
    LOAD_RULE_MASTER_SUCCESS,
    LOAD_RULE_MASTER_FAILURE,
    INIT_LOAD_RULE_MASTER_ACTION_STATUS,
    SELECT_RULE_MASTER,
    OPEN_ADD_OR_EDIT_RULE_MASTER_MODAL,
    ADD_OR_EDIT_RULE_MASTER_CHANGE_INPUT,
    RESET_ADD_OR_EDIT_RULE_MASTER_MODAL,
    START_SAVE_RULE_MASTER,
    SAVE_RULE_MASTER_SUCCESS,
    SAVE_RULE_MASTER_FAILURE,
    INIT_SAVE_RULE_MASTER_ACTION_STATUS,
    START_DELETE_RULE_MASTER,
    DELETE_RULE_MASTER_SUCCESS,
    DELETE_RULE_MASTER_FAILURE,
    INIT_DELETE_RULE_MASTER_ACTION_STATUS,
    ADD_RULE_MASTER_GRID_TO_PROPS,
} from './ruleMasterConstants';

import {
    LOAD_ASSET_INST_CLASS_SUCCESS,
} from '../../home/homeConstants';

const Option = Select.Option;

function option(value) {
    return <Option key={value} value={value}>{value}</Option>;
}

const emptyFields = {
    id: undefined,
    ruleId: '',
    status: 'Active',
    category: undefined,
    country: '',
    fund: undefined,
    expType: '',
    expMeasure: '',
    expMetric: '',
    assetClass: '',
    reportThreshold: '',
    alertThreshold: '',
    deadline: '',
    effectiveFrom: undefined,
    effectiveTo: undefined,
    remarks: '',
    lastModifiedDate: undefined,
    lastModifiedBy: '',
};

const initialState = {
    ruleMasterQueryFields: {
        category: 'All',
        fund: 'All',
        showAll: false,
    },
    selectedRuleMasterArray: [],
    categoryOptions: ['All', 'Disclosure', 'PPM', 'Internal Limit'].map(option),
    fundOptions: ['All', 'PMSF', 'PCF', 'VCC'].map(option),
    statusOptions: ['Active', 'Paused'].map(option),
    assetClassOptions: [],
    addOrEditRuleMasterModal: {
        isOpened: false,
        mode: 'ADD',
        fields: emptyFields,
    },
};

function normalizeModalFields(data, mode) {
    if (!data) {
        return emptyFields;
    }

    return {
        ...emptyFields,
        ...data,
        id: mode === 'COPY' ? undefined : data.id,
        effectiveFrom: data.effectiveFrom ? moment(data.effectiveFrom) : undefined,
        effectiveTo: data.effectiveTo ? moment(data.effectiveTo) : undefined,
    };
}

function ruleMasterQueryInputChange(state, { name, value }) {
    return {
        ...state,
        ruleMasterQueryFields: {
            ...state.ruleMasterQueryFields,
            [name]: value,
        },
    };
}

function startLoadRuleMaster(state) {
    return {
        ...state,
        loadRuleMasterActionStatus: ACTION_STATUS.LOGINING,
    };
}

function loadRuleMasterSuccess(state, payload) {
    return {
        ...state,
        loadRuleMasterActionStatus: ACTION_STATUS.SUCCESS,
        loadRuleMasterActionResp: payload,
    };
}

function loadRuleMasterFailure(state, err) {
    return {
        ...state,
        loadRuleMasterActionStatus: ACTION_STATUS.ERROR,
        loadRuleMasterActionResp: err,
    };
}

function initLoadRuleMasterActionStatus(state) {
    return {
        ...state,
        loadRuleMasterActionStatus: ACTION_STATUS.READY,
    };
}

function selectRuleMaster(state, array) {
    return {
        ...state,
        selectedRuleMasterArray: array,
    };
}

function openAddOrEditRuleMasterModal(state, { mode, data }) {
    return {
        ...state,
        addOrEditRuleMasterModal: {
            isOpened: true,
            mode,
            fields: normalizeModalFields(data, mode),
        },
    };
}

function addOrEditRuleMasterChangeInput(state, { name, value }) {
    return {
        ...state,
        addOrEditRuleMasterModal: {
            ...state.addOrEditRuleMasterModal,
            fields: {
                ...state.addOrEditRuleMasterModal.fields,
                [name]: value,
            },
        },
    };
}

function resetAddOrEditRuleMasterModal(state) {
    return {
        ...state,
        addOrEditRuleMasterModal: {
            isOpened: false,
            mode: 'ADD',
            fields: emptyFields,
        },
    };
}

function startSaveRuleMaster(state) {
    return {
        ...state,
        saveRuleMasterActionStatus: ACTION_STATUS.LOGINING,
    };
}

function saveRuleMasterSuccess(state, payload) {
    return {
        ...state,
        saveRuleMasterActionStatus: ACTION_STATUS.SUCCESS,
        saveRuleMasterActionResp: payload,
    };
}

function saveRuleMasterFailure(state, err) {
    return {
        ...state,
        saveRuleMasterActionStatus: ACTION_STATUS.ERROR,
        saveRuleMasterActionResp: err,
    };
}

function initSaveRuleMasterActionStatus(state) {
    return {
        ...state,
        saveRuleMasterActionStatus: ACTION_STATUS.READY,
    };
}

function startDeleteRuleMaster(state) {
    return {
        ...state,
        deleteRuleMasterActionStatus: ACTION_STATUS.LOGINING,
    };
}

function deleteRuleMasterSuccess(state, payload) {
    return {
        ...state,
        deleteRuleMasterActionStatus: ACTION_STATUS.SUCCESS,
        deleteRuleMasterActionResp: payload,
    };
}

function deleteRuleMasterFailure(state, err) {
    return {
        ...state,
        deleteRuleMasterActionStatus: ACTION_STATUS.ERROR,
        deleteRuleMasterActionResp: err,
    };
}

function initDeleteRuleMasterActionStatus(state) {
    return {
        ...state,
        deleteRuleMasterActionStatus: ACTION_STATUS.READY,
    };
}

function addRuleMasterGridToProps(state, grid) {
    return {
        ...state,
        ruleMasterGrid: grid,
    };
}

function loadAssetInstClassSuccess(state, resp) {
    const assetInstClass = resp.data;
    const assetClassArray = assetInstClass.assetClassList;
    const assetClassOptions = assetClassArray.map(assetClass => <Option key={assetClass}>{assetClass}</Option>);

    return {
        ...state,
        assetClassOptions,
    };
}

export default createReducer(initialState, {
    [RULE_MASTER_QUERY_INPUT_CHANGE]: ruleMasterQueryInputChange,
    [START_LOAD_RULE_MASTER]: startLoadRuleMaster,
    [LOAD_RULE_MASTER_SUCCESS]: loadRuleMasterSuccess,
    [LOAD_RULE_MASTER_FAILURE]: loadRuleMasterFailure,
    [INIT_LOAD_RULE_MASTER_ACTION_STATUS]: initLoadRuleMasterActionStatus,
    [SELECT_RULE_MASTER]: selectRuleMaster,
    [OPEN_ADD_OR_EDIT_RULE_MASTER_MODAL]: openAddOrEditRuleMasterModal,
    [ADD_OR_EDIT_RULE_MASTER_CHANGE_INPUT]: addOrEditRuleMasterChangeInput,
    [RESET_ADD_OR_EDIT_RULE_MASTER_MODAL]: resetAddOrEditRuleMasterModal,
    [START_SAVE_RULE_MASTER]: startSaveRuleMaster,
    [SAVE_RULE_MASTER_SUCCESS]: saveRuleMasterSuccess,
    [SAVE_RULE_MASTER_FAILURE]: saveRuleMasterFailure,
    [INIT_SAVE_RULE_MASTER_ACTION_STATUS]: initSaveRuleMasterActionStatus,
    [START_DELETE_RULE_MASTER]: startDeleteRuleMaster,
    [DELETE_RULE_MASTER_SUCCESS]: deleteRuleMasterSuccess,
    [DELETE_RULE_MASTER_FAILURE]: deleteRuleMasterFailure,
    [INIT_DELETE_RULE_MASTER_ACTION_STATUS]: initDeleteRuleMasterActionStatus,
    [ADD_RULE_MASTER_GRID_TO_PROPS]: addRuleMasterGridToProps,
    [LOAD_ASSET_INST_CLASS_SUCCESS]: loadAssetInstClassSuccess,
});
